import Sale from "../../../../utilities/data/model/Sale";
import { Transitions } from "../../../../utilities/finite-state-machine/types";

export type SaleState =
  | "OPEN"
  | "CANCELLED"
  | "CLOSED"
  | "SAVED"
  | "VOIDED"
  | "LAYBY_OPEN"
  | "LAYBY_SAVED"
  | "LAYBY_CLOSED"
  | "INVOICE_OPEN"
  | "INVOICE_SAVED"
  | "INVOICE_CLOSED"
  | "QUOTE_OPEN"
  | "QUOTE_SAVED"
  | "QUOTE_CLOSED"
  | "LAYBY_CANCELLED"
  | "INVOICE_CANCELLED"
  | "PROFORMA_CLOSED"
  | "PROFORMA_SAVED"
  | "QUOTE_CANCELLED";

export const saleStateTransitions: Transitions<SaleState> = {
  OPEN: {
    to: [
      "SAVED",
      "QUOTE_SAVED",
      "INVOICE_SAVED",
      "LAYBY_SAVED",
      "CANCELLED",
      "CLOSED",
      "OPEN",
      "LAYBY_OPEN",
      "LAYBY_CLOSED",
      "INVOICE_CLOSED",
      "QUOTE_OPEN",
      "INVOICE_OPEN",
      "QUOTE_CLOSED",
      "QUOTE_CANCELLED",
      "LAYBY_CANCELLED",
      "INVOICE_CANCELLED",
    ],
  },
  SAVED: {
    to: [
      "LAYBY_SAVED",
      "LAYBY_OPEN",
      "SAVED",
      "CANCELLED",
      "CLOSED",
      "VOIDED",
      "INVOICE_SAVED",
      "INVOICE_OPEN",
      "QUOTE_SAVED",
      "QUOTE_CLOSED",
      "QUOTE_OPEN",
      "QUOTE_CANCELLED",
      "LAYBY_CANCELLED",
      "INVOICE_CANCELLED",
    ],
  },
  PROFORMA_SAVED: { to: ["PROFORMA_SAVED", "PROFORMA_CLOSED"] },
  PROFORMA_CLOSED: { to: ["PROFORMA_CLOSED"] },
  CLOSED: { to: ["VOIDED"] },
  VOIDED: { to: [] },
  CANCELLED: { to: [] },
  LAYBY_CLOSED: { to: ["LAYBY_CLOSED"] },
  LAYBY_OPEN: {
    to: [
      "LAYBY_OPEN",
      "OPEN",
      "LAYBY_SAVED",
      "LAYBY_CLOSED",
      "LAYBY_CANCELLED",
    ],
  },
  LAYBY_SAVED: {
    to: ["LAYBY_SAVED", "LAYBY_OPEN", "LAYBY_CLOSED", "LAYBY_CANCELLED"],
  },
  INVOICE_OPEN: {
    to: [
      "INVOICE_CANCELLED",
      "OPEN",
      "INVOICE_OPEN",
      "INVOICE_SAVED",
      "INVOICE_CLOSED",
    ],
  },
  QUOTE_OPEN: {
    to: ["QUOTE_OPEN", "QUOTE_SAVED", "QUOTE_CLOSED", "QUOTE_CANCELLED"],
  },
  QUOTE_SAVED: {
    to: ["QUOTE_SAVED", "QUOTE_OPEN", "QUOTE_CLOSED", "QUOTE_CANCELLED"],
  },
  INVOICE_SAVED: {
    to: [
      "INVOICE_SAVED",
      "INVOICE_OPEN",
      "INVOICE_CLOSED",
      "INVOICE_CANCELLED",
    ],
  },
  INVOICE_CLOSED: { to: ["INVOICE_CLOSED"] },
  QUOTE_CLOSED: { to: ["QUOTE_CLOSED"] },
  LAYBY_CANCELLED: { to: [] },
  INVOICE_CANCELLED: { to: [] },
  QUOTE_CANCELLED: { to: [] },
};

export interface SaleTransitionData {
  sale: Sale;
}
